import React from 'react';
import { Container, Row, Col} from 'react-bootstrap';
import { FaCheckCircle, FaBullseye, FaUsers } from 'react-icons/fa';
import fundo3 from '../../img/ingles/whoweare.png'
import './NossoTeam.css'

const OurTeam = () => {
  return (
    <div className="section">
      {/* Primeiro Bloco */}
      <div className="block1">
      <div className="content">
        {/* Adicione conteúdo aqui */}
      </div>
    </div>




      {/* Segundo Bloco */}
      <Container className="my-5">
        <Row>
          <Col>
            <h2 style={{color:'#ff5722'}}>Learn about our history</h2>
            <p>"Our journey began with a powerful commitment: to offer integrated, high-quality solutions for the needs of our clients. With specialized professionals in the areas of building maintenance, information technology, and consulting, our 
              goal is to provide complete, efficient, and innovative services.

From the beginning, our mission has
 been to transform the way our clients manage their building and technological assets, 
 always with a clear focus on sustainable results and personalized service. We believe that 
 each client is unique, and that is why we always strive to understand their specific needs, 
 offering tailor-made solutions.</p></Col>
        </Row>
      </Container>

      {/* Terceiro Bloco */}
      <Container className="my-5">
        <Row>
          <Col md={6}>
            <img src={fundo3} alt="Imagem" className="img-fluid" />
          </Col>
          <Col md={6}>
            <Row>
              <Col>
                <div className="text-center">
                  <FaCheckCircle size={50} color='#ff5722' />
                  <h4>Vision</h4>
              

                  </div>
                  <p>To position itself as a leading company in the sales of products and services nationwide</p>
                
              </Col>
              <Col>
                <div className="text-center">
                  <FaBullseye size={50} color='#ff5722' />
                  <h4>Mission</h4>
          

                  </div>
                  <p>To offer competitive advantages, aligned with the Strategic Plan of our Clients/Partners
                    , with the aim of helping them achieve their objectives, always 
                    providing smart, cost-effective, and innovative solutions in order to add value to their business.</p>
            
              </Col>
              <Col>
                <div className="text-center">
                  <FaUsers size={50} color='#ff5722' />
                  <h4>Values</h4>
                  </div>
                  <div>
                    <p>Gratitude and Appreciation: 
                      We are grateful for the business partnerships we establish and value partners who 
                      contribute to our growth
</p>
<p>
Trust: We prioritize security above all
</p>
<p>
Quality and Safety: We prioritize quality in everything we do and place safety above all
</p>
                  </div>
                 
                
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>


     
    </div>
  );
}

export default OurTeam;
